import { Box, Typography } from '@mui/material';
import useController from '../controllers/nested-products-controller';
import TableTabs from 'components/controls/table-tabs';
import { ResponsePlaceDto } from 'features/place/types/dtos';
import OWContainer from 'styles/styled-components/ow-container';
import { MaterialReactTable } from 'material-react-table';
import React from 'react';

export const NestedProductsRoute = () => {
    const { tableSettings, placeId, activePlace, handleTabChange, places, handleAddNestedProduct } = useController();

    if (places?.content.length === 0) {
        return (
            <Box>
                <Typography>This website has no places</Typography>
            </Box>
        );
    }

    return (
        <React.Fragment>
            {placeId !== '' && (
                <TableTabs<ResponsePlaceDto>
                    active={!!activePlace}
                    id={placeId}
                    handleAdd={handleAddNestedProduct}
                    handleTabChange={handleTabChange}
                    tabData={places?.content}
                >
                    {activePlace && (
                        <OWContainer>
                            <MaterialReactTable table={tableSettings} />
                        </OWContainer>
                    )}
                </TableTabs>
            )}
        </React.Fragment>
    );
};
